import { CommonModule } from '@angular/common';
import { Component, forwardRef } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CheckoutFormComponent } from './checkout-form.component';
export namespace NCheckoutFormCms {
    export const BLOCK_ID = 'cms-checkout-form';
    export type IBlockData = Catalog.IBlockData<IBlockDataContent>;
    export interface IBlockDataContent {
        /**
         * Bottom image
         */
        bottomImage?: string;
        /**
         * Bottom image ratio
         */
        bottomImageRatio?: string;
        /**
         * Bottom copy
         */
        bottomCopy?: string;
    }
}
/**
 * Component definition
 */
@Component({
    selector: 'cms-checkout-form',
    template: '<checkout-form [content]="content"></checkout-form>',
    standalone: true,
    imports: [CommonModule, forwardRef(() => CheckoutFormComponent)]
})
@ICmsComponent<CheckoutFormCmsComponent>({
    id: NCheckoutFormCms.BLOCK_ID,
    block: {
        url: NCheckoutFormCms.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Checkout page layout',
    description: 'Checkout page layout block',
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-bottom',
            title: 'Bottom'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'bottomImage',
            title: 'Bottom image'
        },
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            key: 'bottomImageRatio',
            title: 'Bottom image ratio',
            options: RatioOptions
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'bottomCopy',
            title: 'Bottom copy'
        }
    ]
})
export class CheckoutFormCmsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCheckoutFormCms.IBlockDataContent;
    protected override canDetach = false;
}
